import { oneSignalConstants } from "../../_constants";

const initialState = {};
//login reducer
export const set_onesignal_device_token_for_notification_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case oneSignalConstants.SET_ONESIGNAL_DEVICE_TOKEN_FOR_NOTIFICATION_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case oneSignalConstants.SET_ONESIGNAL_DEVICE_TOKEN_FOR_NOTIFICATION_ACTION_SUCCESS:
      return {
        type: "alert-success",
        oneSignalDeviceId: action.payload,
      };
    case oneSignalConstants.SET_ONESIGNAL_DEVICE_TOKEN_FOR_NOTIFICATION_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};
